import { render, staticRenderFns } from "./Info_Terms_Content.vue?vue&type=template&id=7c3060eb&"
import script from "./Info_Terms_Content.vue?vue&type=script&lang=js&"
export * from "./Info_Terms_Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports